import React from 'react'
import ExpertUnsubscribe from './ExpertUnsubscribe'
import './ExpertUnsubscribe.sass'

export default ({ growlStore, ...params }) => {
  return <ExpertUnsubscribe growlStore={growlStore} {...params} />
}
